module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('ul', {
    staticClass: "main"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("经营主体入网数")]), _vm._v(" "), _c('span', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 990,
      "duration": 5000
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(1), _c('span', [_vm._v("待审核经营主体")]), _vm._v(" "), _c('span', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 10,
      "duration": 5000
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(2), _c('span', [_vm._v("经营限制农药")]), _vm._v(" "), _c('span', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 100,
      "duration": 5000
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(3), _c('span', [_vm._v("批发商")]), _vm._v(" "), _c('span', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 100,
      "duration": 5000
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(4), _c('span', [_vm._v("零售商")]), _vm._v(" "), _c('span', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 100,
      "duration": 5000
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(5), _c('span', [_vm._v("店铺交易活跃")]), _vm._v(" "), _c('span', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 800,
      "duration": 5000
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/icon1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/icon2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/icon3.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/icon4.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/icon5.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/icon6.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-759a636a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/tourupin/components/list/index.vue
// module id = 2045
// module chunks = 2